import { EditableItemsProps } from './EditableItems';

export const useEditableItems = (items: Props['items'], onChange: Props['onChange']) => {
	const handleRemove = (indexToRemove: number) => {
		if (!onChange) return;

		const newItems = items.filter((_item, index) => index !== indexToRemove);

		return onChange(newItems);
	};

	const handleAdd = () => {
		if (!onChange) return;

		const newItems = [...items, ''];

		return onChange(newItems);
	};

	const handleChange = (index: number, value: string) => {
		if (!onChange) return;

		const newItems = [...items];
		newItems[index] = value;

		return onChange(newItems);
	};

	return { handleChange, handleAdd, handleRemove };
};

type Props = Pick<EditableItemsProps, 'items' | 'onChange'>;
